import script from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=0548b14e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0548b14e"]])

export default __exports__